import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

import logo from '~/assets/img/faces/joe-gardner-2.jpg';
import { SubHeader } from '~/components/SubHeader';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';

import {
	ContentPerfil,
	ContentLeft,
	ContentRight,
	ContentPerfilTextLeft,
	ContentPerfilTextRight,
	FotoPerfil,
	H3Right,
	PerfilText,
	DivDados,
} from './styles';

function Perfil() {
	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Perfil',
						link: '/client/perfil',
					},
				]}
			/>

			<Row className="my-5 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Meu Perfil</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Link
						to="/client/dashboard"
						style={{ color: `${color.blue}` }}>
						Voltar para home
					</Link>
				</Col>
			</Row>
			<Card>
				<CardBody>
					<ContentPerfil>
						<ContentLeft>
							<FotoPerfil src={logo} />
							<ContentPerfilTextLeft>
								<Text>Tipo de Conta</Text>
								<Text>Dona da Cadeia</Text>
							</ContentPerfilTextLeft>
							<ContentPerfilTextLeft>
								<Text>Máquina Física Fácil</Text>
								<Text>Plano XYZ</Text>
							</ContentPerfilTextLeft>
							<ContentPerfilTextLeft>
								<Text>Lucree por click</Text>
								<Text>Plano XYZ</Text>
							</ContentPerfilTextLeft>
						</ContentLeft>

						<ContentRight>
							<ContentPerfilTextRight>
								<H3Right>Dados Pessoais</H3Right>
								<DivDados>
									<PerfilText>Nome completo:</PerfilText>
									<Text>Fulano de tal</Text>
								</DivDados>
								<DivDados>
									<PerfilText>CPF:</PerfilText>
									<Text>000.000.000-03</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Data de Nascimento:</PerfilText>
									<Text>02/09/2010</Text>
								</DivDados>
								<DivDados>
									<PerfilText>E-mail:</PerfilText>
									<Text>fulano@gmail.com</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Telefone:</PerfilText>
									<Text>(82) 99104 9240</Text>
								</DivDados>
							</ContentPerfilTextRight>

							<ContentPerfilTextRight>
								<H3Right>Endereço</H3Right>
								<DivDados>
									<PerfilText>Rua/Avenida:</PerfilText>
									<Text>Rua tal</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Número:</PerfilText>
									<Text>552</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Complemento:</PerfilText>
									<Text>Ap 102</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Cidade:</PerfilText>
									<Text>São Paulo</Text>
								</DivDados>
								<DivDados>
									<PerfilText>Estado:</PerfilText>
									<Text>SP</Text>
								</DivDados>
							</ContentPerfilTextRight>
						</ContentRight>
					</ContentPerfil>
				</CardBody>
			</Card>
		</Container>
	);
}

export default Perfil;
